import * as React from "react";
import {lazyInject} from "@athena-portal/core";
import {IWithRouterProps, Overlay, withRouter} from "@athena-portal/components";
import {Types, IFalconPropositionEngine, productHelper, InteractionHelper} from "@ferry/journey-services";
import {Navigate} from "react-router";
import {RetrieveQuoteFailureMessagePage} from "./RetrieveQuoteFailureMessagePage";
import {PluginTemplates} from "@ferry/plugin-ferry-journey";

interface IState {
    interaction?: any;
    journey?: any;
    loadingInteraction?: boolean;
    loadingJourney?: boolean;
}

interface IParams {
    product?: any;
    process?: any;
    interactionId?: any;
    languageCode?: any;
    email?: any;
    dateOfBirth: any;
    [key: string]: string | undefined;
}

export class RetrieveQuotePagePlain extends React.Component<IWithRouterProps<IParams>, IState> {

    @lazyInject(Types.FalconPropositionEngine)
    private propositionEngine: IFalconPropositionEngine;

    private pluginTemplates = new PluginTemplates();

    constructor(props: IWithRouterProps<IParams>) {
        super(props);
        this.state = {};
    }

    public componentDidMount() {
        this.pluginTemplates.setPageTitle("Quote retrieve");

        this.setState({ loadingInteraction: true, loadingJourney: true });

        const product = this.props.params.product;
        const process = this.props.params.process;
        const interactionId = this.props.params.interactionId;
        const languageCode = this.props.params.languageCode;
        const email = this.props.params.email;
        const dateOfBirth = this.props.params.dateOfBirth;

        const decodedProduct: any = productHelper.decodeShortenedProduct(product);

        this.propositionEngine.fetchInteractionByEmailAndDob(decodedProduct, interactionId, email, dateOfBirth).subscribe(
            (interaction: any) => {
                if (InteractionHelper.hasQuoteExpired(interaction)) {
                    this.setState({ interaction, loadingInteraction: false });
                    this.fetchJourney(decodedProduct, process, interactionId, languageCode, email, dateOfBirth);
                    return;
                }

                // DriveAwayInsurance
                if (interaction?.annualCoverInteractionId) {

                    const annualInteractionId = interaction.annualCoverInteractionId;
                    const annualProduct = "AnnualMotorInsurance";

                    this.propositionEngine.fetchInteractionByEmailAndDob(annualProduct, annualInteractionId, email, dateOfBirth).subscribe(
                        (annualInteraction: any) => {
                            this.setState({ interaction: annualInteraction, loadingInteraction: false });
                            this.fetchJourney(annualProduct, process, annualInteractionId, languageCode, email, dateOfBirth);
                        }
                    );

                    // AnnualMotorInsurance
                } else {
                    this.setState({ interaction, loadingInteraction: false });
                    this.fetchJourney(decodedProduct, process, interactionId, languageCode, email, dateOfBirth);
                }
            },
            (error: any) => {
                this.setState({ loadingInteraction: false, loadingJourney: false, interaction: null, journey: null });
            }
        );
    }

    public fetchJourney(product:string, process:string, interactionId:string, languageCode:string, email:string, dateOfBirth:string) {
        this.propositionEngine.fetchJourneyByInteractionEmailAndDob(product, process, interactionId, languageCode, email, dateOfBirth).subscribe(
            (journey: any) => {
                this.setState({ journey, loadingJourney: false });
            },
            (error: any) => {
                this.setState({ loadingInteraction: false, loadingJourney: false, interaction: null, journey: null });
            }
        );
    }

    public render() {
        if (this.state.loadingInteraction || this.state.loadingJourney) {
            return <Overlay show={true}/>
        }

        const {
            interaction,
            journey
        } = this.state;

        if (interaction && interaction.headerInfo && interaction.status && journey) {
            if (InteractionHelper.hasQuoteExpired(interaction)) {
                const newQuoteUrl: string = "/journey/init/product/" + productHelper.decodeShortenedProduct(interaction.product) + "/process/nb";
                return (
                    <RetrieveQuoteFailureMessagePage message={
                        <span>Your quote has expired.
                        <a href={newQuoteUrl} id="newQuote"> Start quote again</a>
                    </span>}/>
                );
            } else if (interaction.status === "BINDING_QUOTE") {
                return (
                    <Navigate to={"/journey/show/product/" + interaction.product + "/process/nb/summary/" + interaction._id}/>
                )
            }
        }

        return (
            <RetrieveQuoteFailureMessagePage message="Quote not found, please enter details again..."/>
        );
    }
}

export const RetrieveQuotePage = withRouter<{}, IParams>(RetrieveQuotePagePlain)
